import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useConfigStore } from '@/stores/config'

/**
 * Изменение document.title
 *
 * @param { string } title - meta.title из роутера
 * @returns { null }
 */
export default function setPageTitle(title) {
    const translatereStore = useTranslaterStore()
    const configStore = useConfigStore()
    const appName = computed(() => configStore.appName)
    const getTranslate = computed(() => translatereStore.getTranslate)
    document.title = getTranslate.value[title] + ' - ' + appName.value
}
